import script from "./AddLetters.vue?vue&type=script&setup=true&lang=js"
export * from "./AddLetters.vue?vue&type=script&setup=true&lang=js"

import "./AddLetters.vue?vue&type=style&index=0&id=4542acd6&lang=scss"

const __exports__ = script;

export default __exports__